module.exports = __webpack_public_path__ + "media/images/emblems/Massongex-coat_of_arms-f741dc61e66be930d84e2e3ef30612bf.svg";